import React, {useEffect, useRef} from 'react';
import './header.css';
import Aos from "aos";
import 'aos/dist/aos.css';
import MyPhoto from "../../images/image-header.jpg";
import { FaLocationArrow } from "react-icons/fa";

const Header = ({observer, setActiveNav}) => {
    const sectionRef = useRef(null)

    useEffect(() => {
        Aos.init({duration:1500})
    }, [])

    useEffect(() => {
        if (observer) {
            observer.observe(sectionRef.current)
        }
    }, [sectionRef, observer])

    return (
        <header>
            <div className="container header_container">
                <div id="header" className="hero" ref={sectionRef}>
                    <p className="eyebrow hero_eyebrow">
                        <span className="eyebrow_line" aria-hidden="true" />
                        <span className="hero_service">Interior design</span>
                        <span className="hero_separator" aria-hidden="true">·</span>
                        <span className="hero_service">Architectural sketches</span>
                        <span className="hero_separator" aria-hidden="true">·</span>
                        <span className="hero_service">Visualisation</span>
                    </p>
                    <h1>Design ideas, <em>clearly visualised.</em></h1>
                    <p className="sub">
                        Interior and exterior sketches, architectural perspectives and floor plans crafted for designers, architects and property teams worldwide.
                    </p>
                    <div className="header_buttons">
                        <a href="#portfolio" className="btn btn-primary">Explore selected work <FaLocationArrow /></a>
                        <a href="#contact" className="btn btn-secondary">Discuss your project <FaLocationArrow /></a>
                    </div>
                    <div className="hero_proof" aria-label="Studio highlights">
                        <div><span className="hero_stat_value">200+</span><span>projects delivered</span></div>
                        <div><span className="hero_stat_value">2–4 days</span><span>typical turnaround</span></div>
                        <div><span className="hero_stat_value">Worldwide</span><span>remote collaboration</span></div>
                    </div>
                </div>
                <div data-aos='zoom-in' data-aos-duration='2000' className='me'>
                    <img src={MyPhoto} alt='Yana Trofimova' className='header_image'/>
                    <div className="image_note"><p>From first line<br/>to final atmosphere</p></div>
                </div>
                {/*<HeaderButtons/>*/}
                {/*<HeaderSocials/>*/}
                {/*<a href='#contact' onClick={() => setActiveNav('#contact')} className='scroll_down'>Scroll Down</a>*/}
            </div>
        </header>
    );
};

export default Header;
